import { FC } from 'react'

import { isRussia, isUS } from 'env'
import { CompanyRuAdd } from './CompanyDetail/CompanyGeneral/CompanyRuAdd'
import { USAddCompanyModal } from './components/USCompanyModals/USAddCompanyModal'
import { AddWorldCompany } from './WorldModals/AddWorldCompany'

type Props = {
  setAddCompanyModalOpen: (payload: boolean) => void
  refreshCompanies: () => void
  parentCompanyId?: string
}

export const AddCompanyControl: FC<Props> = ({ setAddCompanyModalOpen, refreshCompanies, parentCompanyId }) => {
  if (isRussia) {
    return <CompanyRuAdd onClose={() => setAddCompanyModalOpen(false)} refreshCompanies={refreshCompanies} />
  }

  if (isUS) {
    return (
      <USAddCompanyModal
        onSuccess={refreshCompanies}
        parentId={parentCompanyId}
        onClose={() => setAddCompanyModalOpen(false)}
      />
    )
  }

  return <AddWorldCompany onClose={() => setAddCompanyModalOpen(false)} refreshCompanies={refreshCompanies} />
}
